export const limitLongString = (str: string, chars: number): string => {
    if (str.length < chars) return str
    return str.slice(0, chars - 3) + '...'
} 